import clsx from "clsx";
import React from "react";
import { HStack } from "web/react/emo/h-stack";
import { View } from "web/react/emo/view";
import * as styles from "./archive-device-divider.css";

function Divider(): React.ReactElement {
    return (
        <HStack dataTestId="divider" justify={"space-between"}>
            <div className={styles.deviceDividerLeft}>
                <div className={styles.deviceDivider} />
            </div>
            <div className={styles.deviceDividerRight}>
                <div className={styles.deviceDivider} />
            </div>
        </HStack>
    );
}

export interface ArchiveDeviceDividerProps {
    overlap?: boolean;
    children: React.ReactElement[];
}

/**
 * Design System
 * @name ArchiveDeviceDivider
 * @version 1.0
 * @design https://www.figma.com/file/EJXteyeEMjMgKETDQiZDli/Design-Sprint%3A-FY24-Home?type=design&node-id=3796-21417&mode=design&t=msdlxslZ4KOz53KA-0
 */
export function ArchiveDeviceDivider({
    overlap,
    children,
}: ArchiveDeviceDividerProps): React.ReactElement {
    return (
        <View width="full">
            {children.map((child, i) => {
                return overlap ? (
                    <>
                        <div
                            className={clsx(styles.overlapDivider, styles.topOverlapDivider)}
                            data-testid="top-divider"
                        >
                            <Divider />
                        </div>
                        {child}
                        <div
                            className={clsx(styles.overlapDivider, styles.bottomOverlapDivider)}
                            data-testid="bottom-divider"
                        >
                            <Divider />
                        </div>
                    </>
                ) : (
                    <>
                        <View marginY={{ sm: "md", lg: "lg" }}>
                            <Divider />
                        </View>
                        {child}
                        {i === children.length - 1 && (
                            <View marginY={{ sm: "md", lg: "lg" }}>
                                <Divider />
                            </View>
                        )}
                    </>
                );
            })}
        </View>
    );
}
